import { Link } from "react-router-dom";
import { getFormatedDate, getStatusBadge, getStatusText } from "../../Utility";
import "../../assets/styles/global.scss";
import { ThreeDots } from "react-bootstrap-icons";
import { formateStatus } from "../../utils/util";

export const ExtensionColumns = [
  {
    name: "Project Title",
    selector: (row) => (
      <div className="">
        <Link to={`/extension/${row?.id}`}>{row?.projectTitle}</Link>
      </div>
    ),
  },
  // {
  //   name: "Location",
  //   selector: (row) => row?.location,
  // },
  {
    name: "Organization",
    selector: (row) => row?.organizationName,
  },
  {
    name: "Status",
    selector: (row) => getStatusText(row?.applicationStatus) ?? "",
  },
  {
    name: "Start Date",
    selector: (row) => getFormatedDate(row?.startDate),
  },
  {
    name: "End Date",
    selector: (row) => getFormatedDate(row?.endDate),
  },
  // {
  //   name: "Action",
  //   selector: (row) => <ThreeDots width={30} height={30} />,
  //   width : "80px"
  // },
];
